import { readStoredJson, writeStoredJson } from "../services/versionedStorage";

/** Browser persistence is optional so restricted and private sessions still render. */
export const safeRead = readStoredJson;
export const safeWrite = writeStoredJson;

export function downloadText(name: string, text: string, type = "text/plain") {
  const blob = new Blob([text], { type });
  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = name;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  setTimeout(() => URL.revokeObjectURL(url), 500);
}

export const nowTime = () => new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
